import gql from 'graphql-tag';

const ListProductMutation = gql`
  mutation ListProduct($sessionId: String!, $thinkificProductId: String!) {
    listProduct(
      sessionId: $sessionId
      thinkificProductId: $thinkificProductId
    ) {
      thinkificProductId
      shopifyProductId
      name
      imageUrl
      instructor
      status
    }
  }
`;

export default ListProductMutation;
